<template>
  <div class="login-container">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">

      <div class="title-container">
        <h3 class="title">用户登录</h3>
      </div>

      <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
        <el-input
          ref="username"
          v-model="loginForm.username"
          placeholder="请输入用户名或手机号"
          name="username"
          type="text"
          tabindex="1"
          auto-complete="on"
        />
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input
          :key="passwordType"
          ref="password"
          v-model="loginForm.password"
          :type="passwordType"
          placeholder="请输入密码"
          name="password"
          tabindex="2"
          auto-complete="on"
          @keyup.enter.native="handleLogin"
        />
        <span class="show-pwd" @click="showPwd">
          <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
        </span>
      </el-form-item>
      <el-form-item prop="loginValid">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input
          ref="loginValid"
          v-model="loginForm.loginValid"
          placeholder="验证码"
          maxlength="4"
          @keyup.enter.native="handleLogin"
        />
        <img
          id="validImg"
          class="show-valid"
          :src="valImgSrc"
          alt=""
          width="100px"
          height="42px"
          title="看不清？刷一下试试！"
          @click="getGenVerifyPic"
        >
      </el-form-item>
      <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="handleLogin">Login</el-button>

      <div class="tips">
        <!--        <span style="margin-right:20px;">username: admin</span>-->
        <!--        <span> password: any</span>-->
      </div>

    </el-form>
  </div>
</template>

<script>
import { validUsername } from '@/utils/validate'
import { GenVerifyPicRequest } from '@/../grpc/manager_grpc_web_pb'

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('请输入正确的用户名'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 3) {
        callback(new Error('密码长度不能少于3位'))
      } else {
        callback()
      }
    }
    const validateLoginValid = (rule, value, callback) => {
      // console.log(rule, '+', value, '+', callback)
      if (value.length < 4) {
        callback(new Error('请输入4位验证码'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        loginValid: '',
        password: '',
        picId: ''
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePassword }],
        loginValid: [{ required: true, trigger: 'blur', validator: validateLoginValid }]
      },
      loading: false,
      passwordType: 'password',
      valImgSrc: '',
      valImgId: '',
      overtime: '',
      redirect: undefined
    }
  },
  computed: {
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  mounted() {
    this.overtime = new Date()
    this.getGenVerifyPic()
    // 如果是手动退出用户
    if (this.$route.query.status === 1) {
      // 刷新验证图
      this.changeValImg()
      // 重置倒计时
      this.overtime = new Date()
    }

    // checkScreen
    // if (document.body.clientWidth < 1024) {
    //   this.$message.warning('请横屏使用本系统')
    // }
  },
  methods: {
    getGenVerifyPic() {
      const picReq = new GenVerifyPicRequest()
      picReq.setWidth(100)
      picReq.setHeight(42)
      picReq.setNoisecount(4)
      picReq.setLength(4)
      picReq.setSource('123456789')

      this.client.managerGenVerifyPic(picReq, {}, (err, GenVerifyPicReply) => {
        if (err == null) {
          // console.log(GenVerifyPicReply)
          this.valImgId = GenVerifyPicReply.getId()
          this.valImgSrc = GenVerifyPicReply.getPic()
        } else {
          this.$message.error('获取验证码失败')
          console.log(err)
        }
      })
    },
    changeValImg() {
      // 刷新验证图
      this.getGenVerifyPic()
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.loginForm.picId = this.valImgId
          // this.$store.dispatch('模块名/action名', 参数)
          this.$store.dispatch('user/login', { params: this.loginForm }).then(() => {
            this.$router.push({ path: this.redirect || '/' })
            this.loading = false
          }).catch(() => {
            this.loading = false
            this.changeValImg()
          })
        } else {
          // console.log('error submit!!')
          this.changeValImg()
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg:#283443;
$light_gray:#fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #97c6f8;
$dark_gray:#889aa4;
$light_gray:#eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-image:url('../../assets/indexbg-new.png');
  overflow: hidden;

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .login-form {
    background-color: #44709a;
    position: relative;
    height: 500px;
    width: 520px;
    max-width: 100%;
    padding: 80px 35px 0;
    margin: 120px 450px 0px auto;
    overflow: hidden;
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .show-valid {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
</style>
